module.exports = __webpack_public_path__ + "media/assets/images/blog/app_map-f470ae375184324652e8621e8dbc70f2.png";